export function quickActions(data) {
  return {
    type: 'QUICK_ACTIONS',
    payload: data
  };
}

export function quickActionsReset(data) {
  return {
    type: 'QUICK_ACTIONS_RESET',
    payload: data
  };
}